import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    FocusItemKey: null,
    FocusItemKeyDict: null,
    TabsActiveKey: null,
}

export const LogSettingSlice = createSlice({
    name: 'LogSettingSlice',
    initialState,
    reducers: {
        addFocusItemKey: (state, action) => {
            state.FocusItemKey = action.payload
        },
        addFocusItemKeyDict: (state, action) => {
            state.FocusItemKeyDict = action.payload
        },
        addTabsActiveKey: (state, action) => {
            state.TabsActiveKey = action.payload
        },
    },
    extraReducers: {},
})
